import { Component, Input } from '@angular/core';
import { LogisticAgentDetails } from '../../../_services/admin-logistic-partner.service';
import { DocumentService } from '../../../_services/document.service';

@Component({
    selector: 'app-logistic-agent-detail',
    templateUrl: './logistic-agent-detail.component.html',
    styleUrls: ['./logistic-agent-detail.component.css'],
    standalone: false
})
export class LogisticAgentDetailComponent {
    @Input() partner: LogisticAgentDetails;

    constructor(private documentService: DocumentService) {}

    downloadDocument(documentId: string, documentPath: string): void {
        const fileName = documentPath.split('/').pop() || 'document';

        this.documentService.downloadDocumentAdminById(documentId).subscribe({
            next: (blob: Blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
            error: () => {
                console.error('Error downloading document');
            }
        });
    }
}
